import { render, staticRenderFns } from "./text-editor.vue?vue&type=template&id=a5b19e02&"
import script from "./text-editor.vue?vue&type=script&lang=ts&"
export * from "./text-editor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports